module.exports = require("./a");


/*****************
 ** WEBPACK FOOTER
 ** ./chunks/runtime/b.js
 ** module id = 9
 ** module chunks = 5
 **/